import * as React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from '@mui/material';
import Slide from '@mui/material/Slide';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const AlertDialogQuestion = ({
  handlePositive,
  handleNegative,
  textButtonPositive = 'Aceptar',
  textButtonNegative = 'Cancelar',
  dialogContentText,
  dialogTitle,
  open,
  elemento,
  showCancelButton = true 
}) => {
  return (
    <Dialog
      open={open}
      onClose={handleNegative}
      TransitionComponent={Transition}
      keepMounted
      fullWidth
      maxWidth="xs"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle
        sx={{
          textAlign: 'center',
          fontWeight: 'bold',
          fontSize: '1.25rem'
        }}
      >
        {dialogTitle}
      </DialogTitle>

      <DialogContent>
        <div
          id="alert-dialog-slide-description"
          style={{
            textAlign: 'left',
            fontSize: '1rem',
            padding: '8px'
          }}
        >
          {dialogContentText}
        </div>

        {elemento}
      </DialogContent>

      <DialogActions sx={{ justifyContent: 'center', paddingBottom: 2 }}>
       <Button
          onClick={handlePositive}
          variant="contained"
          sx={{
            backgroundColor: '#1976D2',
            color: 'white',
            fontWeight: 'bold',
            '&:hover': {
              backgroundColor: '#115293'
            }
          }}
        >
          {textButtonPositive}
        </Button>
        {showCancelButton && (
          <Button
            onClick={handleNegative}
            variant="outlined"
            color="secondary"
            sx={{ mr: 1 }}
          >
            {textButtonNegative}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default AlertDialogQuestion;
